export default (filters) => {
	if(filters) {
		let count = 0;
		Object.keys(filters).forEach((filter) => {
			let increment;
			if(filters[filter]?.value !== null && filters[filter]?.value !== undefined) {
				const isBoolean = typeof filters[filter].value === 'boolean';
				increment = isBoolean ? 1 : filters[filter].value.length;
			} else if(filters[filter] !== null && filters[filter] !== undefined) {
				const isBoolean = typeof filters[filter] === 'boolean';
				increment = isBoolean ? 1 : filters[filter].length;
			} else {
				increment = 0;
			}
			count += increment;
		});
		return count;
	}
	return 0;
}